import BoxContainerV2 from '@components/Components/Reusables/BoxContainerV2';
import CardContainer from '@components/Components/Reusables/CardContainer';
import FileUploader from '@components/Components/Reusables/FileUploader';
import { Span } from '@components/Components/Reusables/Typography/P';
import { doesObjectHaveEmptyValues, validEmail } from '@components/config/helpers';
import TextInput from '@components/Custom/Inputs/TextInput';
import useAuth from '@components/_hooks/useAuth';
import useFieldChange from '@components/_hooks/useFieldChange';
import useFileUploader from '@components/_hooks/useFileUploader'
import { Stack } from '@mui/material';
import React, { useEffect, useState } from 'react'

const UploadArtwork = () => {
    const {multiUpload} = useFileUploader();
    const [loading, setLoading] = useState(false);

    const {getUser, getDefaultAccount} = useAuth();
    const user = getUser();
    const company = getUser()?.details?.company_name || '';

    const [formDetails, setFormDetails] = useState({
        name: user ? user.name : '',
        company_name: company,
        email_address: user ? user.email : '',
    })

    useEffect(() => {
        if(user != false){
            setFormDetails({
                name: user ? user.name : '',
                company_name: company,
                email_address: user ? user.email : '',
            })
        }
    }, [user])
    

    const validation = (name, value) => {
        switch (name) {
            case 'email_address':
                let text = "";
                const error = !validEmail(value);
                if(error){
                    text = `Invalid email address!`
                }
                return {
                    error,
                    text
                };
            default:
                true
                break;
        }
    }

    const {handleChange, errors, anyErrors} = useFieldChange(setFormDetails, validation)


    const handleUpload = async (files) => {
        setLoading(true);
        const upload = await multiUpload(files, 'artwork', formDetails.email_address, 'upload_artwork', 'upload_artwork', 'upload-artwork', formDetails);
        setLoading(false)
        return upload;
    }

    return (
        <BoxContainerV2
            className="d-flex justify-center" mobileClasses="pl-2 pr-2"
        >

            <CardContainer
                title="Upload Artwork"
                className="mt-4"
                primaryHeader
                sx={{
                    width: {
                        lg: '50%',
                        sm: '100%'
                    }
                }}
                elevation={1}
                padding

            >
                <Stack className="mt-3" spacing={2}>
                    <Span color="grey">Enter your name, company name and email address to upload your PDF(s) </Span>
                    <TextInput 
                        name="name" 
                        onChange={handleChange} 
                        value={formDetails.name} 
                        placeholder="Your name..." 
                        inputProps={{
                            disabled: user ? true : false
                        }}
                        required 
                    />
                    <TextInput 
                        name="company_name" 
                        onChange={handleChange} 
                        value={formDetails.company_name} 
                        placeholder="Your company name..." 
                        inputProps={{
                            disabled: user ? true : false
                        }}
                        required
                    />
                    <TextInput 
                        name="email_address" 
                        onChange={handleChange} 
                        value={formDetails.email_address} 
                        placeholder="Your email address..." 
                        error={errors?.email_address?.error && formDetails.email_address != ""}
                        helperText={errors?.email_address?.text}
                        inputProps={{
                            disabled: user ? true : false
                        }}
                        required
                    />
                    <FileUploader 
                        directory="upload-artwork"
                        onSubmit={handleUpload}
                        accept={{
                            'application/pdf': []
                        }}
                        disabled={anyErrors() || doesObjectHaveEmptyValues(formDetails)}
                        loading={loading}
                    />
                </Stack>
            </CardContainer>
        </BoxContainerV2>
    )
}

export default UploadArtwork